module.exports = __webpack_public_path__ + "static/img/2.a85c7df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgzgk/2.png
// module id = asSW
// module chunks = 0